import i18n from '../i18n';
import { blogImages } from './blogImages';

const getBlogData = () => {
  const currentLang = i18n.language || 'fi';
  const blogData = i18n.getResource(currentLang, 'blogData');

  return Object.keys(blogData).map((slug) => ({
    slug,
    ...blogData[slug],
    images: blogImages[slug] || {},
  }));
};

export default getBlogData;
